import { UserCircleIcon } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import { getNormalizedSegments, getSegmentsArray } from '../../../utils/comparativeSegmentsHelper';

export default function ComparativeHourWiseTable({ comparativeData, selectedHourWiseTab, comparativeSegmentsMeta }) {
  const [comparativeHourBreakdown, setComparativeHourBreakdown] = useState(null);
  const [userHourBreakdown, setUserHourBreakdown] = useState(null);
  const [columnTitles, setColumnTitles] = useState(null);
  const [segments, setSegments] = useState({});

  useEffect(() => {
    const normalizedSegments = getNormalizedSegments(comparativeSegmentsMeta);
    setSegments(normalizedSegments);
  }, [comparativeSegmentsMeta]);

  useEffect(() => {
    if (!comparativeData || !selectedHourWiseTab) return undefined;
    setComparativeHourBreakdown(comparativeData?.comparativeData?.hour_wise_breakdown);
    const hourWiseData = comparativeData?.userData?.hour_wise_breakdown;
    setUserHourBreakdown(hourWiseData);
    setColumnTitles(hourWiseData?.map((item) => item.title));
  }, [comparativeData, selectedHourWiseTab]);

  if (!comparativeHourBreakdown || !userHourBreakdown || !selectedHourWiseTab || !columnTitles) return null;

  if (!segments || Object.keys(segments).length === 0) return null;

  const renderComparativeRow = (segment) => (
    <tr key={segment.key} className="border-b border-[var(--q3-stroke-light)] hover:bg-[var(--q3-surface-dim)]">
      <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
        <div className="flex items-center px-4 gap-4 text-[var(--q3-neutral-default)]">
          <segment.icon size={24} />
          <p className="truncate text-base font-semibold">{segment.title}</p>
        </div>
      </td>
      {comparativeHourBreakdown?.map((item, index, arr) => {
        return (
          <td
            key={index}
            className={`text-center text-[var(--q3-neutral-default)] ${index < arr.length - 1 && 'border-r border-[var(--q3-stroke-light)]'}`}
          >
            {selectedHourWiseTab?.title?.toLowerCase() === 'overall'
              ? item?.values?.[segment.key]?.total
              : item?.values?.[segment.key]?.[selectedHourWiseTab?.title?.toLowerCase()]}
          </td>
        );
      })}
    </tr>
  );

  const comparativeSegmentsArray = getSegmentsArray(segments, 'topper');

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-[318px] text-start border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[300px] leading-snug">Students</div>
            </td>
            {columnTitles.map((text, idx, arr) => (
              <td
                key={idx}
                className={`py-3 px-4 min-w-[180px] text-center align-middle ${
                  idx < arr.length - 1 ? 'border-r border-[var(--q3-stroke-light)]' : ''
                }`}
              >
                <div className="line-clamp-2 max-w-[180px] mx-auto leading-snug text-[var(--q3-neutral-default)]">
                  {text}
                </div>
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-[var(--q3-stroke-light)] hover:bg-[var(--q3-surface-dim)]">
            <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
              <div className="flex items-center px-4 gap-4 text-[var(--q3-neutral-default)]">
                <UserCircleIcon size={24} />
                <p className="truncate text-base font-semibold">You</p>
              </div>
            </td>
            {userHourBreakdown?.map((item, index, arr) => {
              return (
                <td
                  className={`text-center text-[var(--q3-neutral-default)] ${index < arr.length - 1 && 'border-r border-[var(--q3-stroke-light)]'}`}
                >
                  {selectedHourWiseTab?.title?.toLowerCase() === 'overall'
                    ? item?.values?.total
                    : item?.values[selectedHourWiseTab?.title?.toLowerCase()]}
                </td>
              );
            })}
          </tr>

          {comparativeSegmentsArray.map((segment) => renderComparativeRow(segment))}
        </tbody>
      </table>
    </div>
  );
}
